import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 text-center">
      <h1 className="display-1 fw-bold">404</h1>
      <p className="fs-4 mt-3">Page Not Found</p>
      <Link to="/" className="btn btn-primary mt-4">
        Go Home
      </Link>
    </div>
  );
}